import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#6DA544",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), a = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M11.304 23.913a2.609 2.609 0 0 0 2.609 2.609h7.826c0 1.2.973 2.174 2.174 2.174h2.608a2.174 2.174 0 0 0 2.174-2.174v-2.609h-17.39Zm17.609-12.609v6.087c0 .96-.78 1.74-1.74 1.74v2.608a4.353 4.353 0 0 0 4.348-4.348v-6.087h-2.608Zm-18.696 6.087c0 .96-.78 1.74-1.739 1.74v2.608a4.353 4.353 0 0 0 4.348-4.348v-6.086h-2.609v6.086Z"
}, null, -1), h = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M25 11.304h2.608v6.087H25v-6.087Zm-3.913 3.479a.435.435 0 0 1-.87 0v-3.479H17.61v3.479a.435.435 0 0 1-.87 0v-3.479h-2.61v3.479a3.047 3.047 0 0 0 3.044 3.043c.646 0 1.245-.203 1.739-.548a3.025 3.025 0 0 0 2.123.523 1.74 1.74 0 0 1-1.688 1.33v2.608a4.353 4.353 0 0 0 4.347-4.348v-6.087h-2.608v3.479Z"
}, null, -1), v = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M14.13 19.13h3.913v2.61H14.13v-2.61Z"
}, null, -1), c = [
  n,
  a,
  h,
  v
];
function s(i, d) {
  return e(), l("svg", o, [...c]);
}
const r = { render: s };
export {
  r as default,
  s as render
};
